import { z } from 'zod'

export const RDashboardNotification = z.object({
	Id: z.optional(z.number()),
	IsPersonal: z.boolean(),
	Notification: z.string(),
	EffectiveOn: z.string(),
	ExpiresOn: z.string(),
})
export type DashboardNotification = z.infer<typeof RDashboardNotification>
